




















































import { Component, Prop, Vue } from 'vue-property-decorator';
import HoverDescription from '@/components/atoms/HoverDescription.vue';
import ProductCjkLogo from '@/components/atoms/logo/ProductCjkLogo.vue';
import ProductCsrLogo from '@/components/atoms/logo/ProductCsrLogo.vue';
import ProductCtmLogo from '@/components/atoms/logo/ProductCtmLogo.vue';
import ProductCwsLogo from '@/components/atoms/logo/ProductCwsLogo.vue';
import PortalMenuSkeltonLoader from '@/components/atoms/skelton/PortalMenuSkeltonLoader.vue';
import ProductMenuLinks from '@/components/molecules/ProductMenuLinks.vue';
import { getUrlTarget } from '@/containers/globals/Util';
import { i18n } from '@/plugins/i18n/i18n';
import { ID, Product, ProductMenu } from '@/types/type';
import { REL } from '@/utils/consts';

export interface ProductRootMenu {
  id: ID;
  title: string;
  url: string;
  product: Product;
}

type Consumer<T> = () => T;

type ImageCreator<T> = {
  [key in Product]: Consumer<T>;
};

@Component({
  components: {
    PortalMenuSkeltonLoader,
    HoverDescription,
    ProductCsrLogo,
    ProductCwsLogo,
    ProductCjkLogo,
    ProductCtmLogo,
  },
})
export default class PortalProductRootMenus extends Vue {
  @Prop()
  private loading!: boolean;

  @Prop()
  private rootMenus!: ProductRootMenu[];

  private get panelTitle(): string {
    return i18n.tc('portal.application');
  }

  private click(menu: ProductRootMenu): void {
    window.open(menu.url, getUrlTarget(menu.product), REL);
  }
}
